import React, { Component } from 'react';
import './Separator.css';
import EditBar from '../EditBar/EditBar';

class Separator extends Component {
  toggleEditing(toggle) {
    if (this.props.onToggleEditing) {
      this.props.onToggleEditing(toggle);
    }
  }

  render() {
    const {
      separatorSize,
      separatorSolid,
      sectionIndex,
      contentBlockIndex,
      removeContentBlock
    } = this.props;

    return (
      <div
        className={`separator ${
          separatorSolid ? 'solid' : ''
        } ${separatorSize} edit-wrapper`}
      >
        <hr />

        <EditBar
          toggleEditing={() => this.toggleEditing(true)}
          removeContentBlock={() =>
            removeContentBlock(sectionIndex, contentBlockIndex)
          }
        />
      </div>
    );
  }
}

export default Separator;



// WEBPACK FOOTER //
// ./src/components/landingPage/Separator/Separator.js